import {
  Badge,
  Box,
  Flex,
  Icon,
  IconButton,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Text,
  Button,
  Divider,
  Center
} from "@chakra-ui/react";
import { useNotificationContext } from "contexts/notification-context";
import { FiBell } from "react-icons/fi";

function BellSVGIcon() {
  return (
    <Icon viewBox="0 0 24 24" boxSize="20px" fill="currentColor">
      <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6V11c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z" />
    </Icon>
  );
}

function formatDate(isoString: string) {
  try {
    return new Date(isoString).toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
      hour: "2-digit",
      minute: "2-digit"
    });
  } catch {
    return isoString;
  }
}

export function NotificationBell() {
  const {
    notifications,
    unreadCount,
    markAsRead,
    clearNotifications,
    isLoading
  } = useNotificationContext();

  return (
    <Popover placement="bottom-end">
      <PopoverTrigger>
        <Box
          position="relative"
          mr="6px"
          // bg="bg-gray"
          borderRadius="full"
          w="45px"
          h="45px"
          display="flex"
          justifyItems="center"
          alignItems="center"
        >
          <IconButton
            w="45px"
            h="45px"
            aria-label="Notificações"
            icon={<FiBell size="20px" />}
            variant="ghost"
            color="gray.800"
            borderRadius="full"
            _hover={{ bg: "gray.200" }}
            size="sm"
          />
          {unreadCount > 0 && (
            <Center
              position="absolute"
              top="-2px"
              right="-2px"
              color="white"
              bg="red.600"
              borderRadius="full"
              fontSize="10px"
              minW="16px"
              h="16px"
              display="flex"
              alignItems="center"
              justifyContent="center"
              pointerEvents="none"
            >
              {unreadCount > 10 ? "10+" : unreadCount}
            </Center>
          )}
        </Box>
      </PopoverTrigger>

      <PopoverContent w="400px" maxH="480px" overflow="hidden" shadow="lg">
        <PopoverHeader>
          <Flex justifyContent="space-between" alignItems="center">
            <Text fontWeight="600" fontSize="14px">
              Notificações
            </Text>
            {notifications.length > 0 && (
              <Button
                variant="ghost"
                size="xs"
                color="gray.500"
                onClick={clearNotifications}
              >
                Limpar tudo
              </Button>
            )}
          </Flex>
        </PopoverHeader>

        <PopoverBody overflowY="auto" maxH="400px" p="0">
          {notifications.length === 0 ? (
            <Flex
              direction="column"
              alignItems="center"
              justifyContent="center"
              py="40px"
              gap="8px"
              color="gray.400"
            >
              <BellSVGIcon />
              <Text fontSize="13px">Nenhuma notificação</Text>
            </Flex>
          ) : (
            notifications.map((notification, index) => (
              <Box key={notification.id}>
                <Flex
                  direction="row"
                  alignItems="center"
                  px="16px"
                  py="12px"
                  bg={notification.read ? "white" : "blue.50"}
                  _hover={{ bg: "gray.50" }}
                  transition="background 0.15s"
                >
                  <Flex direction="column" flex="1" gap="4px">
                    {notification.payload.titulo && (
                      <Text fontSize="14px" fontWeight="600" color="gray.800" lineHeight="1.4">
                        {notification.payload.titulo}
                      </Text>
                    )}
                    <Text fontSize="12px" color="gray.500" lineHeight="1.4">
                      {notification.payload.mensagem}
                    </Text>
                    <Flex justifyContent="space-between" alignItems="center" mt="4px">
                      <Text fontSize="11px" color="gray.400">
                        {formatDate(notification.sentAt)}
                      </Text>
                      <Flex gap="4px">
                        {!notification.isRead && (
                          <Button
                            variant="ghost"
                            size="xs"
                            color="blue.500"
                            fontSize="11px"
                            onClick={(e) => { e.stopPropagation(); markAsRead(notification.id); }}
                            isLoading={isLoading}
                            loadingText="Marcando..."
                          >
                            Marcar como lido
                          </Button>
                        )}
                      </Flex>
                    </Flex>
                  </Flex>
                  {!notification.read && (
                    <Box
                      w="8px"
                      h="8px"
                      borderRadius="full"
                      bg="blue.500"
                      flexShrink={0}
                      ml="10px"
                    />
                  )}
                </Flex>
                {index < notifications.length - 1 && <Divider my="0" />}
              </Box>
            ))
          )}
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}
